import { NEARBY } from "@/data/project";
import { MapPin } from "lucide-react";

const Location = () => {
  return (
    <section
      id="ubicacion"
      data-testid="location-section"
      className="relative py-24 md:py-32 bg-[var(--co-bg)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16 items-center">
        {/* Text */}
        <div>
          <span className="inline-flex items-center gap-2 text-[var(--co-accent)] uppercase tracking-[0.25em] text-xs font-semibold">
            <span className="h-px w-8 bg-[var(--co-accent)]" />
            01 · Ubicación estratégica
          </span>
          <h2 className="mt-6 font-display text-[var(--co-primary)] text-4xl md:text-5xl font-bold tracking-tight leading-[1.05]">
            Al frente de la nueva Ciudad Judicial.
            <br />
            <span className="text-[var(--co-accent)]">A la entrada de Costa Oeste.</span>
          </h2>
          <p className="mt-6 text-[var(--co-text-muted)] text-lg leading-relaxed max-w-xl">
            La plaza está en la <strong className="text-[var(--co-primary)]">única vía de acceso</strong> al
            Residencial Costa Oeste: las 3,000 familias que ya viven ahí pasan por la plaza{" "}
            <strong className="text-[var(--co-primary)]">cada vez que entran o salen</strong>. Sumado a 2,500 colaboradores
            judiciales al frente, no es una opción — es <strong className="text-[var(--co-primary)]">parada obligada</strong>.
          </p>

          <ul className="mt-10 divide-y divide-[var(--co-border)] border-y border-[var(--co-border)]">
            {NEARBY.map((n, i) => (
              <li
                key={n.name}
                data-testid={`nearby-item-${i}`}
                className="py-5 flex items-start gap-4"
              >
                <span className="mt-1 text-[var(--co-accent)]">
                  <MapPin className="w-5 h-5" />
                </span>
                <div className="flex-1">
                  <p className="font-display font-bold text-[var(--co-primary)] text-base md:text-lg">
                    {n.name}
                  </p>
                  <p className="text-sm text-[var(--co-text-muted)] mt-1">{n.detail}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Map / Aerial image */}
        <div className="relative">
          <div className="relative">
            <div className="aspect-[4/5] w-full overflow-hidden bg-[var(--co-primary)] border border-[var(--co-border)]">
              <img
                src="https://customer-assets.emergentagent.com/job_trusting-ritchie-2/artifacts/8k7n3sj2_DJI_0287.JPG"
                alt="Vista aérea — Ciudad Judicial y Costa Oeste Plaza"
                className="w-full h-full object-cover"
                data-testid="location-aerial-image"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[var(--co-primary)] text-white p-6 md:p-8 max-w-xs hidden sm:block">
              <p className="font-display text-2xl md:text-3xl font-bold leading-tight">
                Vía a La Mitra
              </p>
              <p className="text-white/70 text-sm mt-2">
                Junto a la Estación Delta, a pocos pasos del Hospital Nicolás A. Solano.
              </p>
            </div>
          </div>

          {/* Google Maps embed - centered on the plaza showing Ciudad Judicial + Vía a La Mitra + Delta */}
          <div className="mt-16 border border-[var(--co-border)] bg-white overflow-hidden">
            <iframe
              title="Costa Oeste Plaza · Google Maps"
              data-testid="google-map-embed"
              src="https://maps.google.com/maps?q=Delta%20Costa%20Oeste%20La%20Chorrera&ll=8.860348,-79.770711&t=m&z=16&output=embed&iwloc=near"
              width="100%"
              height="320"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
            <a
              data-testid="google-map-open"
              href="https://maps.app.goo.gl/D5QJt61Dspd3bsTRA"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-5 py-3 text-xs uppercase tracking-[0.2em] font-bold text-[var(--co-primary)] hover:bg-[var(--co-bg)] border-t border-[var(--co-border)] transition-colors"
            >
              Abrir en Google Maps →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
